module.exports = __webpack_public_path__ + "images/emoji/handbag.c779189d4b6c9f41cd60.png";